module.exports = __webpack_public_path__ + "img/logo.a36e6c86.png";